/**
 * True when a key event should NOT drive walkthrough navigation: focus is in
 * a text field, select, contenteditable region, an open dialog/drawer, or the
 * review theater.
 */
export function isTypingOrModalTarget(target: EventTarget | null, doc: Document = document): boolean {
  const el = target instanceof Element ? target : null;
  if (el) {
    if (el.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"], [role="textbox"], [role="combobox"], [role="slider"]')) return true;
    if ((el as HTMLElement).isContentEditable) return true;
    if (el.closest('[role="dialog"], [role="alertdialog"], [data-vaul-drawer], [data-demo-theater]')) return true;
  }
  if (doc.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [data-demo-theater]')) return true;
  return false;
}
